/**
 * @author nick
 * @description 強制登出共用邏輯：後端作廢 token → 清本地狀態 → 導回登入頁。
 * 用於 PageHeader 手動登出，以及 ADR-0002 信箱驗證後強制重登等場景。
 * 注意：後端 deleteToken 失敗時仍執行本地登出（降級處理，避免使用者卡在舊 session）。
*/
import cookies from 'js-cookie';

// # API
import { deleteToken } from 'utils/api';

// ^ Redux
import { resetUserInfoState } from 'layouts/Main/features/userinfo/userinfoSlice';

// ? Self-packed Functions
import { storage, STORAGE_KEYS } from 'utils/storage';

export const forceLogout = async ({ history, dispatch, socketClient }) => {
  try {
    await deleteToken(cookies.get('token'));
  } catch (_) {
    // ! 後端作廢失敗仍繼續本地登出
    _;
  }
  storage.remove(STORAGE_KEYS.USER);
  cookies.remove('token');
  if (socketClient && typeof socketClient.deactivate === 'function') {
    socketClient.deactivate();
  }
  if (dispatch) dispatch(resetUserInfoState());
  history.push('/');
};
